import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const CheckIcon = styled(MUIIcon.CheckCircle)`
	margin-right: 0.5rem;
	font-size: 16px !important;
	color: ${Theme.green};
`;

export const CancelIcon = styled(MUIIcon.Cancel)`
	margin-right: 0.5rem;
	font-size: 16px !important;
	color: ${Theme.red};
`;

export const CloseIcon = styled(MUIIcon.Close)`
	font-size: 16px !important;
	color: ${Theme.red};
`;

export const EditIcon = styled(MUIIcon.Edit)`
	margin-right: 0.5rem;
	font-size: 16px !important;
	color: ${Theme.black};
`;

export const ArrowDownIcon = styled(MUIIcon.KeyboardArrowDown)`
	margin-top: -4px;
	font-size: 20px; 
	color: ${Theme.green} !important;
`;

export const TrashIcon = styled(MUIIcon.Delete)`
	margin-right: 0.5rem;
	font-size: 16px !important;
	color: ${Theme.red};
`;

export const MenuIcon = styled(MUIIcon.MoreHoriz)``;

export const DotIcon = styled(MUIIcon.FiberManualRecord)`
	font-size: 8px !important;
	align-self: center !important;
`;

export const CreditIcon = styled(MUIIcon.CreditCard)``;

export const MoneyIcon = styled(MUIIcon.MonetizationOn)``;

export const LockIcon = styled(MUIIcon.Lock)``;

export const SettingsIcon = styled(MUIIcon.Tune)`
	margin-right: 4px;
	font-size: 16px !important;
	vertical-align: top !important;
`;

export const RefreshInventoryIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	color: ${Theme.white} !important;
`;